import * as Yup from "yup";

export const courseSupportValidation = Yup.object().shape({
  platform: Yup.string().required("وارد کردن نوع پلتفرم الزامی است"),
  link: Yup.string().required("وارد کردن لینک الزامی است"),
  account: Yup.string().required("وارد کردن اکانت الزامی است"),
});
